export function formatNumberAndDot(value?: string): string {
  if (!value) return '';
  return value.replace(/[^0-9.]/g, '');
}

export function formatOnlyNumber(value?: string): string {
  if (!value) return '';
  return value.replace(/\D/g, '');
}

export function formatToPhone(value?: string): string {
  if (!value) return '';
  value = value.replace(/\D/g, '');
  value = value.replace(/^(\d{2})(\d)/, '($1) $2');
  value = value.replace(/(\d{4})(\d)/, '$1-$2');
  return value.slice(0, 14);
}

export function formatToCellphone(value?: string): string {
  if (!value) return '';
  value = value.replace(/\D/g, '');
  value = value.replace(/^(\d{2})(\d)/, '($1) $2');
  value = value.replace(/(\d{5})(\d)/, '$1-$2');
  return value.slice(0, 15);
}

export function formatToCEP(value?: string): string {
  if (!value) return '';
  value = value.replace(/\D/g, '');
  value = value.replace(/^(\d{5})(\d)/, '$1-$2');
  return value.slice(0, 9);
}

export function formatToMoney(value?: string | number): string {
  if (value === undefined || value === null) return '';

  let onlyDigits = String(value).replace(/\D/g, '');

  if (!onlyDigits) return '';

  const intValue = parseFloat(onlyDigits) / 100;

  return intValue.toFixed(2);
}

export function formatToDateBR(value?: string): string {
  if (!value) return '';

  const date = new Date(value);
  if (isNaN(date.getTime())) return '';

  return value.split('T')[0].split('-').reverse().join('/');
}

export function formatToCpfCnpj(value?: string): string {
  if (!value) return '';
  value = value.replace(/\D/g, '');

  if (value.length <= 11) {
    // CPF -> 000.000.000-00
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return value.slice(0, 14); // garante limite
  } else {
    // CNPJ -> 00.000.000/0000-00
    value = value.replace(/^(\d{2})(\d)/, '$1.$2');
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
    return value.slice(0, 18); // garante limite
  }
}
